"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GlobalStyle = void 0;

var _styledComponents = require("styled-components");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  body {\n    font-family: Brandon, sans-serif;\n    background-color: ", ";\n    padding: 0;\n    margin: 0;\n\n    a {\n      text-decoration: none;\n      color: default;\n    }\n  }\n\n  #bodyContainer {\n    z-index: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n\n  #mainWrapper {\n    z-index: 0;\n    position: absolute;\n    top: 0;\n    left: ", ";\n    right: 0;\n    bottom: 0;\n  }\n\n  *,\n  *:after,\n  *:before {\n    box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    /* Safari/Chrome, other WebKit */\n    -moz-box-sizing: border-box;\n    /* Firefox, other Gecko */\n    -webkit-text-size-adjust: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject(), function (_ref) {
  var colors = _ref.theme.colors;
  return colors.background;
}, function (_ref2) {
  var sizes = _ref2.theme.sizes;
  return sizes.sideMenuWidth;
});
exports.GlobalStyle = GlobalStyle;
var _default = GlobalStyle;
exports["default"] = _default;

//# sourceMappingURL=GlobalStyle.js.map